/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Auth_DescInputs */

const en_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick, so you can manage your bookings later.`)
};

const es_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es rápido, y luego podrás gestionar tus reservas.`)
};

const de_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnell, damit Sie Ihre Buchungen später verwalten können.`)
};

const zh_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只需片刻，之后即可管理你的预订。`)
};

const ar_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بسرعة، حتى تتمكّن من إدارة حجوزاتك لاحقاً.`)
};

const fr_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapide, pour que vous puissiez gérer vos réservations plus tard.`)
};

const vi_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhanh thôi, để bạn quản lý lịch đặt sau này.`)
};

const sw_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ni haraka, ili uweze kudhibiti nafasi ulizoweka baadaye.`)
};

const th_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รวดเร็ว เพื่อให้คุณสามารถจัดการการจองของคุณได้ในภายหลัง`)
};

const bs_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavite se sada da biste kasnije mogli upravljati svojim rezervacijama.`)
};

const ja_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すぐに済み、後から予約を管理できます。`)
};

const ko_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`간단합니다. 나중에 예약을 관리할 수 있습니다.`)
};

const pt_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É rápido, e assim você pode gerenciar suas reservas depois.`)
};

const it_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veloce, in modo da poter gestire le prenotazioni più tardi.`)
};

const sv_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det går snabbt, och sedan kan du hantera dina bokningar.`)
};

const nl_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snel, zodat je je boekingen later kunt beheren.`)
};

const da_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det går hurtigt, og så kan du administrere dine bookinger senere.`)
};

const nb_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raskt, så du kan administrere bestillingene senere.`)
};

const fi_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nopeasti, jotta voit hoitaa varauksesi myöhemmin.`)
};

const pl_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybko, więc możesz zarządzać rezerwacjami później.`)
};

const ru_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это быстро — потом вы сможете управлять своими бронированиями.`)
};

const tr_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı, böylece rezervasyonlarınızı daha sonra yönetebilirsiniz.`)
};

const hi_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह जल्दी हो जाता है, ताकि आप बाद में अपनी बुकिंग प्रबंधित कर सकें।`)
};

const id_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cepat, sehingga Anda dapat mengelola pemesanan Anda nanti.`)
};

const ms_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantas, supaya anda boleh mengurus tempahan anda kemudian.`)
};

const cs_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rychle, takže si můžete spravovat rezervace později.`)
};

const el_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γρήγορα, για να διαχειριστείτε τις κρατήσεις σας αργότερα.`)
};

const he_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`זה מהיר, וכך תוכלו לנהל את ההזמנות שלכם בהמשך.`)
};

const af_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinnig, sodat jy jou besprekings later kan bestuur.`)
};

const hu_booking_auth_desc = /** @type {(inputs: Booking_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyorsan, hogy később elintézhesd a foglalásokat.`)
};

/**
* | output |
* | --- |
* | "Quick, so you can manage your bookings later." |
*
* @param {Booking_Auth_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_auth_desc = /** @type {((inputs?: Booking_Auth_DescInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Auth_DescInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_auth_desc(inputs)
	if (locale === "de") return de_booking_auth_desc(inputs)
	if (locale === "zh") return zh_booking_auth_desc(inputs)
	if (locale === "ar") return ar_booking_auth_desc(inputs)
	if (locale === "fr") return fr_booking_auth_desc(inputs)
	if (locale === "vi") return vi_booking_auth_desc(inputs)
	if (locale === "sw") return sw_booking_auth_desc(inputs)
	if (locale === "th") return th_booking_auth_desc(inputs)
	if (locale === "bs") return bs_booking_auth_desc(inputs)
	if (locale === "ja") return ja_booking_auth_desc(inputs)
	if (locale === "ko") return ko_booking_auth_desc(inputs)
	if (locale === "pt") return pt_booking_auth_desc(inputs)
	if (locale === "it") return it_booking_auth_desc(inputs)
	if (locale === "sv") return sv_booking_auth_desc(inputs)
	if (locale === "nl") return nl_booking_auth_desc(inputs)
	if (locale === "da") return da_booking_auth_desc(inputs)
	if (locale === "nb") return nb_booking_auth_desc(inputs)
	if (locale === "fi") return fi_booking_auth_desc(inputs)
	if (locale === "pl") return pl_booking_auth_desc(inputs)
	if (locale === "ru") return ru_booking_auth_desc(inputs)
	if (locale === "tr") return tr_booking_auth_desc(inputs)
	if (locale === "hi") return hi_booking_auth_desc(inputs)
	if (locale === "id") return id_booking_auth_desc(inputs)
	if (locale === "ms") return ms_booking_auth_desc(inputs)
	if (locale === "cs") return cs_booking_auth_desc(inputs)
	if (locale === "el") return el_booking_auth_desc(inputs)
	if (locale === "he") return he_booking_auth_desc(inputs)
	if (locale === "af") return af_booking_auth_desc(inputs)
	if (locale === "hu") return hu_booking_auth_desc(inputs)
	return en_booking_auth_desc(inputs)
});